import React from 'react';

const SensorScoreAggregateFooterCell = ({
    aggregateType,
    className,
    colSpan,
    columnType,
    excelExport = false,
    filteredData,
    field,
    isRuntimeColumn,
    style
}) => {
    if (aggregateType === 'None') {
        if (excelExport) {
            return null;
        }
        else {
            return (
                <td className={className} style={style} colSpan={colSpan}>
                    {''}
                </td>
            );
        }
    }

    let label = '';
    if (field === 'timestamp' || field === 'start') {
        if (aggregateType !== 'None') {
            label = aggregateType;
            if (aggregateType === 'Runtime') {
                label = 'Runtime';
            }
        }

        if (!excelExport) {
            style.textAlign = 'right';
            return (
                <td className={className} style={style} colSpan={colSpan}>
                    {label}
                </td>
            );
        }
        else {
            return label;
        }
    }
    else {
        let trueCount = 0;
        let falseCount = 0;
        let allowAggregate = false;
        let minRunTimeValue, maxRunTimeValue;
        if (columnType === 'numeric' || columnType === 'boolean') {
            allowAggregate = true;
        }

        let value = 'N/A';
        let total = 0;
        const notNullRecordCount = filteredData.data.reduce((acc, current) => (current[field] !== null ? acc + 1 : acc), 0);

        const isBoolean = columnType === 'boolean';
        if (isBoolean) {
            trueCount = filteredData.data.reduce((acc, current) => (current[field] === true ? acc + 1 : acc), 0);
            falseCount = filteredData.data.reduce((acc, current) => (current[field] === false ? acc + 1 : acc), 0);
        }
        if (allowAggregate) {
            if (aggregateType === 'Average') {
                total = filteredData.data.reduce((acc, current) => acc + parseFloat(current[field]), 0);
            }

            switch (aggregateType) {
                case 'Minimum':
                    if (!isBoolean) {
                        value = filteredData.data.reduce((acc, current) => Math.min(acc, current[field]), Number.MAX_VALUE);
                        if (field.includes('ruleVal')) {
                            value = value + '%';
                        }
                    }
                    else {
                        if (trueCount < filteredData.total - trueCount) {
                            value = `${ trueCount } True`;
                        }
                        else {
                            value = `${ filteredData.total - trueCount } False`;
                        }
                    }
                    break;
                case 'Maximum':
                    if (!isBoolean) {
                        value = filteredData.data.reduce((acc, current) => Math.max(acc, current[field]), 0);
                        if (field.includes('ruleVal')) {
                            value = value + '%';
                        }
                    }
                    else {
                        if (trueCount > falseCount) {
                            value = `${ trueCount } True`;
                        }
                        else {
                            value = `${ falseCount } False`;
                        }
                    }
                    break;
                case 'Average':
                    
                    if (!isBoolean) {
                        if (notNullRecordCount > 0) {
                            value = (total / notNullRecordCount);
                            if (!Number.isInteger(value)) {
                                value = value.toFixed(1);
                            }
                            if (field.includes('ruleVal')) {
                                value = value + '%';
                            }
                        }
                    }
                    else {
                        if (trueCount > falseCount) {
                            value = `${ ((trueCount / notNullRecordCount) * 100).toFixed(1) }% True`;
                        }
                        else {
                            value = `${ ((falseCount / notNullRecordCount) * 100).toFixed(1) }% False`;
                        }
                    }
                    break;
                case 'Runtime':
                    if (isRuntimeColumn) {
                        minRunTimeValue = filteredData.data.reduce((acc, current) => Math.min(acc, current[field]), Number.MAX_VALUE);
                        maxRunTimeValue = filteredData.data.reduce((acc, current) => Math.max(acc, current[field]), 0);
                        value = (maxRunTimeValue - minRunTimeValue).toFixed(2);
                    }
                    else {
                        value = 'N/A';
                    }
                    break;
                default:
                    label = '';
                    value = 0;
            }
        }

        if (excelExport) {
            return value;
        }
        else {
            return (
                <td className={className} style={style} colSpan={colSpan}>
                    {
                        aggregateType !== 'None' ?
                            <div>{value}</div>
                            : <div>{''}</div>
                    }
                </td>
            );
        }
    }
};

export default SensorScoreAggregateFooterCell;
